import { useEffect } from "react";
import useNin from "../hooks/common/useNin";
import { TFormHookParams } from "../types/common";

export const useGetOwnerDetails = ({
  form,
  updateFormValues,
  setError,
  optional = [],
}: TFormHookParams) => {
  const { ninError: ninError, success } = useNin(form, updateFormValues);
  useEffect(() => {
    if (setError) {
      setError(ninError);
    }
  }, [ninError]);

  return [
    {
      field_name: "first_name",
      type: "text",
      label: "First Name",
      props: {
        required: optional?.includes("first_name") ? false : true,
        disabled: success,
        smallWidth: true,
      },
    },
    {
      field_name: "last_name",
      type: "text",
      label: "Last Name",
      props: {
        required: optional?.includes("last_name") ? false : true,
        disabled: success,
        smallWidth: true,
      },
    },

    {
      field_name: "phone_number",
      type: "tel",
      label: "Phone Number",
      props: {
        required: optional?.includes("phone_number") ? false : true,
        smallWidth: true,
      },
    },

    {
      field_name: "username",
      type: "text",
      label: "Username",
      props: {
        required: optional?.includes("username") ? false : true,
      },
    },

    {
      field_name: "email",
      type: "email",
      label: "Email",
      props: { required: optional?.includes("email") ? false : true },
    },

    {
      field_name: "tin",
      type: "tin",
      label: "TIN",
      props: {
        maxLength: 14,
      },
    },

    {
      field_name: "physical_address",
      type: "physical_address",
      label: "Physical Address",
      props: {
        required: optional?.includes("physical_address") ? false : true,
      },
    },
  ];
};
